import React from 'react'
import logo from '../../assets/Home/Logo.svg';

function BannerLogo() {
  return (
    <div className='flex w-full h-full justify-center items-center bg-[#EAEAEA] rounded-r-[24px] shadow-[0.25rem_0.25rem_24px_8px_rgba(0,0,0,0.32)]' >
            <img src={ logo } alt='logo_nemu' />
    </div>
  )
}

export {BannerLogo}